import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { activeBreak, getSalonSchedule } from "../../../redux/slice/salonSlice";
import { useLocation } from "react-router-dom";
import Title from "../../extras/Title";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import ScheduleDialogue from "./ScheduleDialogue";
import { permissionError } from "../../../util/Alert";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { IconEdit } from "@tabler/icons-react";

const SalonSchedule = () => {
  const { salonSchedule } = useSelector((state) => state.salon);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

  const state = useLocation();

  console.log("first", state?.state?._id);

  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    dispatch(getSalonSchedule(state?.state?._id));
  }, [dispatch]);

  useEffect(() => {
    setData(salonSchedule);
  }, [salonSchedule]);

  const handleOpenDialog = (row) => {
    dispatch(
      openDialog({
        type: "schedule",
        data: { data: row, salonId: state?.state?._id },
      })
    );
  };

  const formatTime = (time) => {
    if (!time) return "-";

    const [hour, minute] = time.split(":");

    const formattedHour = hour?.padStart(2, "0");
    const formattedMinute = minute?.padStart(2, "0");

    return `${formattedHour}:${formattedMinute}`;
  };

  const scheduleTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },

    {
      Header: "Day",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.day}</span>
      ),
    },
    {
      Header: "Open Time",
      Cell: ({ row }) => (
        <span className="text-capitalize">{formatTime(row?.openTime)}</span>
      ),
    },

    {
      Header: "Closed Time",
      Cell: ({ row }) => <span>{formatTime(row?.closedTime)}</span>,
    },

    {
      Header: "Salon Break Start Time",
      Cell: ({ row }) => (
        <span>{row?.isBreak ? formatTime(row?.breakStartTime) : "-"}</span>
      ),
    },

    {
      Header: "Salon Break End Time",
      Cell: ({ row }) => (
        <span>{row?.isBreak ? formatTime(row?.breakEndTime) : "-"}</span>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            
            onClick={() => {
              if (state?.state?._id === "6617c5ded03f8d115d62afe5")
                return permissionError();

              handleOpenDialog(row);
            }}
          >
            <IconEdit className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="userPage">
      {/* <Title name={`${state?.state?.name}'s Schedule`} /> */}

      <div className="user-table mb-3">
      <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
               {`${state?.state?.name}'s Schedule`}
              </h5>
            </div>
          </div>
        </div>
        <Table
          data={data}
          mapData={scheduleTable}
          serverPerPage={rowsPerPage}
          Page={page}
        />
      </div>
      {dialogue && dialogueType === "schedule" && (
        <ScheduleDialogue setData={setData} data={data} />
      )}
    </div>
  );
};

export default SalonSchedule;
